var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.425 27C22.3 27 19.2125 26.319 16.1625 24.957C13.1125 23.595 10.3375 21.6635 7.8375 19.1625C5.3375 16.6615 3.4065 13.8865 2.0445 10.8375C0.6825 7.7885 0.001 4.701 0 1.575C0 1.125 0.15 0.75 0.45 0.45C0.75 0.15 1.125 0 1.575 0H7.65C8 0 8.3125 0.119 8.5875 0.357C8.8625 0.595 9.025 0.876 9.075 1.2L10.05 6.45C10.1 6.85 10.0875 7.1875 10.0125 7.4625C9.9375 7.7375 9.8 7.975 9.6 8.175L5.9625 11.85C6.4625 12.775 7.056 13.6685 7.743 14.5305C8.43 15.3925 9.1865 16.224 10.0125 17.025C10.7875 17.8 11.6 18.519 12.45 19.182C13.3 19.845 14.2 20.451 15.15 21L18.675 17.475C18.9 17.25 19.194 17.0815 19.557 16.9695C19.92 16.8575 20.276 16.826 20.625 16.875L25.8 17.925C26.15 18.025 26.4375 18.2065 26.6625 18.4695C26.8875 18.7325 27 19.026 27 19.35V25.425C27 25.875 26.85 26.25 26.55 26.55C26.25 26.85 25.875 27 25.425 27Z",
    fill: "#009A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0928b816aea539f68b3948fc5260ecd8.svg";
export { ForwardRef as ReactComponent };